// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card-user .nav-tabs {
    position: relative;
    z-index: 10;
}

/*.card-user .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #d6dbdf;
  background-color: #1e1e2f;
  border-color: #e3e3e3 #e3e3e3 #1e1e2f;
}*/

.card .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-light);
}

.card .nav-tabs {
    border-bottom: none;
    height: 1.2cm
}`, "",{"version":3,"sources":["webpack://./src/assets/css/componentStyles/tabs.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;;;;EAKE;;AAEF;;EAEE,sBAAsB;AACxB;;AAEA;IACI,mBAAmB;IACnB;AACJ","sourcesContent":["\n.card-user .nav-tabs {\n    position: relative;\n    z-index: 10;\n}\n\n/*.card-user .nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #d6dbdf;\n  background-color: #1e1e2f;\n  border-color: #e3e3e3 #e3e3e3 #1e1e2f;\n}*/\n\n.card .nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-light);\n}\n\n.card .nav-tabs {\n    border-bottom: none;\n    height: 1.2cm\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
